import { Component, Input } from '@angular/core'

@Component({
  selector: 'mmx-appointment-fact',
  templateUrl: './appointment-details-fact.component.html',
  standalone: false,
})
export class AppointmentDetailsFactComponent {
  @Input() title: string
}
